/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const featureId = feature.getID();
    const TEMPERATURE = feature.getSettingValue('TEMPERATURE');
    const HUMIDITY = feature.getSettingValue('HUMIDITY');

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    "TEMPERATURE": ${TEMPERATURE},
    "HUMIDITY": ${HUMIDITY},
});`,
    });

    blocks.push({
        location: `var_${TEMPERATURE}_update`,
        blockType: BlockType.CODE,
        template: `var_${TEMPERATURE}_update_completed(Math.floor(simulator.context["${featureId}"]["TEMPERATURE"]));`,
    });

    blocks.push({
        location: `var_${HUMIDITY}_update`,
        blockType: BlockType.CODE,
        template: `var_${HUMIDITY}_update_completed(Math.floor(simulator.context["${featureId}"]["HUMIDITY"]));`,
    });

    // blocks.push({
    //     location: `var_${TEMPERATURE}_set`,
    //     blockType: BlockType.CODE,
    //     template: `ioLineSet("${featureId}", "TEMPERATURE", value)`,
    // });

    // blocks.push({
    //     location: `var_${HUMIDITY}_set`,
    //     blockType: BlockType.CODE,
    //     template: `ioLineSet("${featureId}", "HUMIDITY", value)`,
    // });

    return blocks;
};
